import { css } from 'styled-components';
import { fontColorMixin } from './fontColorMixin';
import { fontFamilyMixin } from './fontFamilyMixin';
import { fontTypeIconAlignmentMixin } from './fontTypeIconAlignmentMixin';
import { fontTypeMediaQueryMixin } from './fontTypeMediaQueryMixin';
import { fontTypeMixin } from './fontTypeMixin';
import { semanticElementMixin } from './semanticElementMixin';
export var TYPOGRAPHY_DEFAULT_PROPS = {
  fontColor: 'textDark',
  fontFamily: 'sansSerif'
};

/** @mixin typographyMixin */
/**
 * Adds all typography related mixins to your component.
 *
 * @example
 * import { typographyMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *    ${typographyMixin}
 * `';
 *
 * <Component
 *     fontType="h1"
 *     fontColor="brand"
 *     fontFamily="serif"
 * >
 *     Typography mixin example
 * </Component>
 *
 * @method
 * @param {object} props
 * @param {string} [props.fontType]
 * @param {string} [props.fontColor]
 * @param {string} [props.fontFamily]
 * @return {Interpolation}
 */
export var typographyMixin = function typographyMixin(props) {
  var forwardedProps = Object.assign({}, TYPOGRAPHY_DEFAULT_PROPS, props);
  return [fontColorMixin(forwardedProps), css(["-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-transform:none;"]), fontFamilyMixin(forwardedProps), fontTypeMixin(forwardedProps), fontTypeIconAlignmentMixin(forwardedProps), fontTypeMediaQueryMixin(forwardedProps), semanticElementMixin(forwardedProps)];
};